import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./_helpers/history";
import appt from "./_helpers/apptStatus";

import FAQ from "./_components/FAQ/FAQPage";
import Reservation from "./_components/Reservation/ReservationPage";
import Confirmation from "./_components/Confirmation/ConfirmationPage";
import RenderAppointmentStatus from "./_components/Status/RenderAppointmentStatus";

import "bootstrap/dist/css/bootstrap.min.css";

class App extends Component {
    constructor(props) {
        super(props)

        history.listen((location) => {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'pageview',
                    page: { url: location.pathname }
                });
            }
        });
    }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route path="/appointment/registered">
            <Confirmation {...appt.registered} />
          </Route>
          <Route path="/appointment/cancelled">
            <Confirmation {...appt.cancelled} />;
          </Route>
          <Route path="/appointment/waitlisted">
            <Confirmation {...appt.waitlisted} />;
          </Route>
          <Route
            path="/appointment/:id"
            render={(props) => <RenderAppointmentStatus {...props} />}
          />
          <Route path="/faq">
            <FAQ />
          </Route>
          <Route path="/" render={props => <Reservation {...props} />}>
            
          </Route>
        </Switch>
      </Router>
    );
  }
}
export default App;
